import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import EligibilityCelebration from '@zr/jobseeker-public/apps/jobseeker-collect-additional-information/components/EligibilityCelebration/EligibilityCelebration';

import {
  ELIGIBILITY_CELEBRATION,
} from '../../../screenTypeSchema';

import { applyDataPropTypes } from '../../../applyFlowPropTypes';

import screenTypeTelemetry from '../screenTypeTelemetry';

import './EligibilityCelebration.less';

export function EligibilityCelebrationScreenType({
  applyData,
  onScreenTypeFinish,
}) {
  const {
    logFinish,
    logView,
  } = screenTypeTelemetry(ELIGIBILITY_CELEBRATION, applyData);

  useEffect(() => {
    logView();
  }, [logView]);

  const handleContinue = async () => {
    logFinish();
    await onScreenTypeFinish();
  };

  return (
    <div className="EligibilityCelebrationScreenType">
      <EligibilityCelebration
        onContinue={handleContinue}
      />
    </div>
  );
}

EligibilityCelebrationScreenType.propTypes = {
  applyData: applyDataPropTypes.isRequired,
  onScreenTypeFinish: PropTypes.func.isRequired,
};

export default EligibilityCelebrationScreenType;
